import { render } from "./index.vue?vue&type=template&id=57066e4f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=57066e4f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-57066e4f"

export default script